import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { Shield, ArrowLeft } from "lucide-react";
import { getReceipt } from "@/lib/api";
import ReceiptDisplay from "@/components/ReceiptDisplay";

export default function PublicReceipt() {
  const { hash } = useParams();
  const [receipt, setReceipt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getReceipt(hash, true)
      .then(setReceipt)
      .catch(() => setError("Receipt not found"))
      .finally(() => setLoading(false));
  }, [hash]);

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50">
      <header className="h-14 border-b border-zinc-800 bg-zinc-950 flex items-center px-4 md:px-6 gap-3">
        <Shield className="h-5 w-5 text-blue-500" strokeWidth={1.5} />
        <span className="text-sm font-semibold tracking-tight">TeardownCierge</span>
        <span className="text-[10px] uppercase tracking-widest text-zinc-600">Public Receipt</span>
      </header>

      <main className="max-w-3xl mx-auto p-4 md:p-8 space-y-6">
        <Link to="/" className="inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-zinc-300">
          <ArrowLeft className="h-3.5 w-3.5" />
          Back to TeardownCierge
        </Link>

        {loading && <p className="text-zinc-500 text-sm py-8 text-center">Loading receipt...</p>}
        {error && (
          <div className="border border-red-500/20 bg-red-500/5 p-6 text-center">
            <p className="text-red-400 text-sm">{error}</p>
            <p className="text-zinc-600 text-xs mt-2 font-mono">{hash}</p>
          </div>
        )}
        {receipt && <ReceiptDisplay receipt={receipt} publicOnly />}

        <div className="border-t border-zinc-800 pt-4 text-center">
          <p className="text-[10px] uppercase tracking-widest text-zinc-600">
            Custody controls the evidence. Authority governs the review. Receipts prove what happened.
          </p>
        </div>
      </main>
    </div>
  );
}
